import { render, staticRenderFns } from "./PageProvisionsverwaltung.vue?vue&type=template&id=02aa782a&scoped=true&"
import script from "./PageProvisionsverwaltung.vue?vue&type=script&lang=js&"
export * from "./PageProvisionsverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./PageProvisionsverwaltung.vue?vue&type=style&index=0&id=02aa782a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aa782a",
  null
  
)

export default component.exports